module.exports = __webpack_public_path__ + "static/fonts/Nexa_Regular.007b563.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Nexa/Nexa_Regular.otf
// module id = T670
// module chunks = 3